<template>
  <div class="elementWidths" :key="`tab_content_4` + $store.state.calculatorData.calculatorPages[4].disabled + `_errors_` + $store.state.calculatorData.calculatorPages[4].errors">
    <div class="row">
      <div class="col-md-6">
        <h2>{{ $t(`elementWidths.title`)}}</h2>
      </div>
      <div class="col-md-6 md-align-right" v-if="elementForm !== ''">
        <p>({{$t(`globals.currentSelectedForm`)}} <strong> {{$t(`elementForm.`+ elementForm +`.pdfTitle`)}}</strong>)</p>
      </div>
    </div>

    <b-button @click="explanationClick()" v-b-toggle.explanation-content-elementWidths variant="primary" class="explanation"> <span v-html="$t(`globals.explanation`)"></span></b-button>
    <b-collapse id="explanation-content-elementWidths" class="explanation-content">
      <b-card>
        <p v-html="$t('elementWidths.infoText')"></p>
      </b-card>
    </b-collapse>
    <div class="row" >
      <div class="technical-draw col-md-5 d-none d-md-block align-self-center">
        <TechnicalDrawing step="elementWidths" :type="`elementwidths_`+elementForm" />
      </div>
      <div class="col-md-7">

        <div class="technical-draw d-md-none">
          <TechnicalDrawing step="elementWidths" :type="`elementwidths_`+elementForm" />
        </div>
        <div v-if="elementForm !== ''">
          <StoSlider name="b" tab="elementWidths" />
          <StoSlider name="e" tab="elementWidths" />

          <div v-if="isBox" class="slider-wrapper input-container highlight-box calculated-box">
            <div class="row space-between">
              <div class="col-md-8">
                  <span v-html="$t(`variablesNice.w`)"></span>
                  <p>W  = B - E - H </p>
                  <p v-if="vacuumPanels === 'vip'" > Enthält 20mm VIP</p>
              </div>
              <div class="col-12 d-md-none text-align-right spacebottom-to-sm">
                <input type="number" :min="min" :max="max" :value="w" class="slider-input disabled" disabled="disabled"> mm
              </div>
              <div class="col-md-4 d-none d-md-block">
                <input type="number" :min="min" :max="max" :value="w" class="slider-input disabled" disabled="disabled"> mm
              </div>

              <div v-if="$store.state.calculatorData.errors['w'] === 'min'" class="col-12 error">
                {{$tc(`elementWidths.werrorMin`, min, {min: calculatorMin.w()})}}
              </div>
              <div v-if="$store.state.calculatorData.errors['w'] === 'max'" class="col-12 error">
                {{$tc(`elementWidths.werrorMax`, max, {max: calculatorMax.w()})}}
              </div>
            </div>
          </div>

          <div class="slider-wrapper input-container highlight-box calculated-box" >
            <div class="row space-between">
              <div class="col-md-8">
                  <span v-html="$t(`variablesNice.h`)"></span>
              </div>
              <div class="col-12 d-md-none text-align-right spacebottom-to-sm">
                <input type="number" :min="min" :max="max" :value="h" class="slider-input disabled" disabled="disabled"> mm
              </div>
              <div class="col-md-4 d-none d-md-block">
                <input type="number" :min="min" :max="max" :value="h" class="slider-input disabled" disabled="disabled"> mm
              </div>
            </div>
          </div>

        </div>
        <div class="info-wrapper">
          <div v-if="$store.state.calculatorData.warnings.elementWidths">
            <p v-if="$store.state.calculatorData.warnings.elementWidths.eIs100" class="info" v-html="$t('elementWidths.triggerInfo2')"></p>
            <!-- <p v-if="$store.state.calculatorData.warnings.elementWidths.eIsLowerThanEquals115" class="info" v-html="$t('elementWidths.eIsLowerThanEquals115')"></p> -->
            <p v-if="$store.state.calculatorData.warnings.elementWidths.widerThanStandard" class="info" v-html="$t('elementWidths.triggerInfo3')"></p>
          </div>
        </div>
      </div>
    </div>
    <StepNavi thisPage="5" :key="`navi_tab5_`+ $store.state.calculatorData.calculatorPages[5].disabled"/>
  </div>
</template>

<script>
import StoSlider from './StoSlider.vue'
import TechnicalDrawing from './TechnicalDrawing.vue'
import StepNavi from './StepNavi.vue'
import { mapGetters } from 'vuex'

export default {
  components: {
    StoSlider,
    TechnicalDrawing,
    StepNavi
  },
  data () {
    return {
      min: Number,
      max: Number,
      textTriggerOpen: false
    }
  },
  computed: {
    ...mapGetters([
      'b',
      'w',
      'h',
      'isBox',
      'calculatorMin',
      'calculatorMax',
      'elementForm',
      'vacuumPanels'
    ])
  },
  methods: {
    explanationClick: function () {
      if (this.textTriggerOpen) {
        this.textTriggerOpen = false
      } else {
        this.$root.$children['0'].userDidAction = true
        this.textTriggerOpen = true
        let tabName = 'elementWidths'
        let gtmEventLabel = this.$(tabName + '.virtualPageTitle')
        let virtualPageURL = '/' + this.$t(tabName + '.virtualPageURL')
        let virtualPageTitle = this.$t(tabName + '.virtualPageTitle')
        this.$root.$children['0'].globalGTMFkt('JKK-Events', 'Erläuterung', 'Button', gtmEventLabel, '', virtualPageURL, virtualPageTitle)
      }
    }
  },
  mounted: function () {
    // console.log('--- elementWidths rendert ---')
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
